import { createFileRoute } from "@tanstack/react-router";
import { AssistenteVisualizarMensagensPage } from "@/paginas/pg_assistente/assistente-visualizar-mensagens";

export const Route = createFileRoute("/_authenticated/assistente-visualizar-mensagens")({
  component: AssistenteVisualizarMensagensPage,
});
